import type { RecursivePartial } from '#root/types/utils'
import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    promosContainer: 'eyebrow c-grey-20',
    variantsContainer: 'c-grey-20'
  }
} satisfies RecursivePartial<CartConfig['item']>
